import { render } from "./DaysAndRequestsShadowCardsComponent.vue?vue&type=template&id=bc5cca94&ts=true"
import script from "./DaysAndRequestsShadowCardsComponent.vue?vue&type=script&lang=ts"
export * from "./DaysAndRequestsShadowCardsComponent.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/tawa.digital.dashboard/tawa.digital.dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__